import { functions } from './db.config';
import { RoomTypes } from '../utils/documentModals/getUserModel';

export type GetToken = {
  roomName: string;
  roomSize: RoomTypes;
  userId: string;
};
export const telehealthtoken = functions.httpsCallable('telehealthGetToken');
